import styled from 'styled-components'

import { cssTypes, displayTypes, gridTypes } from '../types'
import { css, display, grid } from '../util'

/**
 * @namespace Grid
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Grid = styled.div`
  ${css};
  ${display};
  ${grid};
`

/**
 * @name defaultProps
 * @memberof Grid
 * @desc Primitive's default properties
 */
Grid.defaultProps = {
  display: 'grid',
  gridAutoRows: 'auto',
  gridGap: 0,
  gridTemplateColumns: 'none',
}

/**
 * @name propTypes
 * @memberof Grid
 * @desc Primitive's prop type definitions
 */
Grid.propTypes = {
  ...cssTypes,
  ...displayTypes,
  ...gridTypes,
}

/** @component */
export default Grid
